import {
  Box,
  CardActionArea,
  Grid,
  RadioGroup,
  Stack,
  Tooltip,
  alpha,
  styled,
} from "@mui/material";
import { useState } from "react";

// @mui
// hooks
import { BoxMask } from ".";
import { IconButtonAnimate } from "../../../components/animate";
import MenuPopover from "../../../components/MenuPopover";
import useSettings from "../../../hooks/useSettings";

// components

// ----------------------------------------------------------------------

const BoxStyle = styled(CardActionArea)(({ theme }) => ({
  height: 48,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: theme.palette.text.disabled,
  border: `solid 1px ${theme.palette.grey[500_12]}`,
  borderRadius: Number(theme.shape.borderRadius) * 1.25,
}));

export default function ThemeColorChanger() {
  const { themeColorPresets, onChangeColor, colorOption } = useSettings();

  const currentColor = colorOption?.find(
    ({ name }) => name === themeColorPresets
  )?.value;

  const [open, setOpen] = useState(null);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  return (
    <>
      <Tooltip title={"Color palette"}>
        <IconButtonAnimate
          onClick={handleOpen}
          sx={{
            width: 40,
            height: 40,
            ...(open && { bgcolor: "action.selected" }),
          }}
        >
          <Box
            sx={{
              width: 24,
              height: 24,
              borderRadius: "50%",
              bgcolor: currentColor,
              transition: (theme) =>
                theme.transitions.create("all", {
                  easing: theme.transitions.easing.easeInOut,
                  duration: theme.transitions.duration.shorter,
                }),
            }}
          />
        </IconButtonAnimate>
      </Tooltip>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          mt: 1.5,
          ml: 0.75,
          width: 180,
          "& .MuiMenuItem-root": {
            px: 1,
            typography: "body2",
            borderRadius: 0.75,
          },
        }}
      >
        <Stack spacing={0.75}>
          <RadioGroup
            name="themeColorPresets"
            value={themeColorPresets}
            onChange={onChangeColor}
          >
            <Grid dir="ltr" container spacing={1.5}>
              {colorOption.map((color) => {
                const colorName = color.name;
                const colorValue = color.value;
                const isSelected = themeColorPresets === colorName;

                return (
                  <Grid key={colorName} item xs={4}>
                    <Tooltip
                      title={colorName === "default" ? "green" : colorName}
                    >
                      <BoxStyle
                        sx={{
                          ...(isSelected && {
                            bgcolor: alpha(colorValue, 0.08),
                            border: `solid 2px ${colorValue}`,
                            boxShadow: `inset 0 4px 8px 0 ${alpha(
                              colorValue,
                              0.24
                            )}`,
                          }),
                        }}
                      >
                        <Box
                          sx={{
                            width: 24,
                            height: 14,
                            borderRadius: "50%",
                            bgcolor: colorValue,
                            transform: "rotate(-45deg)",
                            transition: (theme) =>
                              theme.transitions.create("all", {
                                easing: theme.transitions.easing.easeInOut,
                                duration: theme.transitions.duration.shorter,
                              }),
                            ...(isSelected && { transform: "none" }),
                          }}
                        />

                        <BoxMask value={colorName} />
                      </BoxStyle>
                    </Tooltip>
                  </Grid>
                );
              })}
            </Grid>
          </RadioGroup>
        </Stack>
      </MenuPopover>
    </>
  );
}
